module.exports = __webpack_public_path__ + "img/pdf-icon.67296c89.png";